import React, { useMemo } from "react";
import { Plane } from "lucide-react";

const RECOMMENDED_DEALS = [
  {
    label: "Next recommended deal",
    title: "Japan Travel eSIM from S$5.00",
    description: "Stay connected before takeoff with instant travel data.",
  },
  {
    label: "Next recommended deal",
    title: "Singapore Travel eSIM from S$5.00",
    description: "Set up local data before you land in Singapore.",
  },
  {
    label: "Next recommended deal",
    title: "Thailand Travel eSIM from S$5.00",
    description: "Book your data plan and keep maps, rides, and support ready.",
  },
  {
    label: "Next recommended deal",
    title: "South Korea Travel eSIM from S$7.00",
    description: "Arrive ready for Seoul with mobile data already sorted.",
  },
  {
    label: "Next recommended deal",
    title: "Malaysia Travel eSIM from S$5.00",
    description: "Cross borders with simple setup and app-only travel perks.",
  },
  {
    label: "Next recommended deal",
    title: "UAE Travel eSIM from S$8.00",
    description: "Keep bookings, data, and support close from one account.",
  },
];

const AuthRecommendedDeal = () => {
  const deal = useMemo(() => {
    const index = Math.floor(Math.random() * RECOMMENDED_DEALS.length);
    return RECOMMENDED_DEALS[index];
  }, []);

  return (
    <div className="auth-trip-card auth-trip-card--recommended">
      <div>
        <Plane size={18} />
        <span>{deal.label}</span>
      </div>
      <strong>{deal.title}</strong>
      <p>{deal.description}</p>
    </div>
  );
};

export default AuthRecommendedDeal;
